import { render, staticRenderFns } from "./SalaryActions.vue?vue&type=template&id=2e3e94be&scoped=true"
import script from "./SalaryActions.vue?vue&type=script&lang=js"
export * from "./SalaryActions.vue?vue&type=script&lang=js"
import style0 from "./SalaryActions.vue?vue&type=style&index=0&id=2e3e94be&prod&scoped=true&lang=css"
import style1 from "./SalaryActions.vue?vue&type=style&index=1&id=2e3e94be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e94be",
  null
  
)

export default component.exports